<aside class="app-sidebar" [class.open]="sidebarService.isOpen()">
  <nav>
    <a
      routerLink="/manuel"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      class="nav-home"
      (click)="closeOnMobile()"
    >
    <span class="material-icons nav-icon">home</span>
      <span class="nav-label">{{ 'nav_home_label' | translate }}</span>
    </a>

    <span class="nav-group-label">{{ 'nav_summary_label' | translate }}</span>

    <a
      *ngFor="let item of items"
      [routerLink]="'/manuel/' + item.path"
      routerLinkActive="active"
      (click)="closeOnMobile()"
    >
      <span class="material-icons nav-icon">{{ item.icon }}</span>
      <span class="nav-label">{{ item.label | translate }}</span>
    </a>
  </nav>
</aside>

<div
  class="sidebar-scrim"
  *ngIf="sidebarService.isOpen()"
  (click)="sidebarService.close()"
></div>
